import { render, staticRenderFns } from "./RelatorioLogFuncao.vue?vue&type=template&id=bfd5f120"
import script from "./RelatorioLogFuncao.vue?vue&type=script&lang=js"
export * from "./RelatorioLogFuncao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports